
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cVptH", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $6g1oe = parcelRequire("6g1oe");


var $eXODy = parcelRequire("eXODy");

parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $8hUXc = parcelRequire("8hUXc");


var $3d5UI = parcelRequire("3d5UI");


var $6Ywr0 = parcelRequire("6Ywr0");


var $cpjd2 = parcelRequire("cpjd2");

class $968e924f2d44dea0$var$PseudoWizardCreateDialogComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        (0, $3IK76.bind)('remove.dialog', this._afterDialogClosed);
        this.forceReloadInNextOpen = true;
        this._setOpenState(this.props.open);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.spaceKey !== nextProps.spaceKey) this.forceReloadInNextOpen = true;
        if (nextProps.open) (0, $eXODy.nativeEditorComponentsPreloader)();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.isOpening = false;
        this.forceReloadInNextOpen = true;
        this._setOpenState = (openState)=>openState ? this._open() : this._close();
        /**
     * Close the create dialog
     * @private
     */ this._close = (e)=>{
            // Destroy the dialog
            if (typeof this._confluenceDialogClose === 'function') {
                // a defensive way to make sure legacy code should not break our React code due to unknown error.
                try {
                    this._confluenceDialogClose();
                } catch (error) {}
                this._confluenceDialogClose = null;
            }
            (0, $3IK76.unbind)('remove.dialog', this._afterDialogClosed);
            this.props.onClose(e);
        };
        /**
     * Triggered after dialog closed
     * @private
     */ this._afterDialogClosed = (e, { dialog: dialog })=>{
            if (dialog.id === 'create-dialog') {
                this._confluenceDialogClose = null;
                this._close(e);
            }
        };
        this._isActive = ()=>!!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('#create-dialog');
        this._open = ()=>{
            if (!this._isActive() && !this.isOpening) {
                const { blueprint: blueprint, spaceKey: spaceKey, templateOriginSpaceKey: templateOriginSpaceKey, parentPageId: parentPageId, title: title, contentId: contentId, onContentUpdated: onContentUpdated, beforeUpdateRequest: beforeUpdateRequest, onError: onError } = this.props;
                if (blueprint) {
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                    });
                    this.isOpening = true;
                    (0, $cpjd2.requireLegacyWRM)([
                        'wrc!com.atlassian.confluence.plugins.dialog-wizard:dialog-wizard-resources',
                        'wrc!create-content'
                    ], ()=>{
                        // Although we've included 'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources' here
                        // The 'link-style-css' may have been executed somewhere else previously.
                        // Requiring it again will not have effect. Here we are going to manually initialize it.
                        (0, $6Ywr0.waitForRequiredModule)({
                            listener: 'PseudoWizardDialog',
                            module: 'ac/confluence/style/link-style-css'
                        }, ()=>{
                            const linkStyleCSS = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('ac/confluence/style/link-style-css');
                            if (linkStyleCSS && typeof linkStyleCSS.addLinkTags === 'function') linkStyleCSS.addLinkTags();
                        });
                        (0, $3d5UI.waitForGlobal)({
                            listener: 'PseudoWizardDialog',
                            globalProperty: 'Confluence.Blueprint.loadDialogAndOpenTemplate'
                        }, ()=>{
                            const { contentBlueprintId: contentBlueprintId, templateId: templateId, itemModuleCompleteKey: itemModuleCompleteKey } = blueprint;
                            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).Confluence.Blueprint.loadDialogAndOpenTemplate({
                                spaceKey: spaceKey,
                                templateOriginSpaceKey: templateOriginSpaceKey,
                                contentBlueprintId: contentBlueprintId,
                                templateId: templateId,
                                initContext: {
                                    itemModuleCompleteKey: itemModuleCompleteKey,
                                    // no-parent-page is the contentId being set inside the drawer state when the user switch space
                                    // it is indicator that new page will be created at the top of the space
                                    // in that case we do not want to specify the parentPageId when sending to backend
                                    parentPageId: parentPageId === 'no-parent-page' ? null : parentPageId
                                },
                                contentId: contentId,
                                onContentUpdated: onContentUpdated,
                                beforeUpdateRequest: beforeUpdateRequest,
                                onError: onError,
                                title: title
                            }).then(()=>{
                                this.isOpening = false;
                                this.forceReloadInNextOpen = false;
                                (0, $fGzMp.getExperienceTracker)().succeed({
                                    name: (0, $irVI7.BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE)
                                });
                            }).fail((response)=>{
                                this.isOpening = false;
                                this.forceReloadInNextOpen = false;
                                (0, $fGzMp.getExperienceTracker)().fail({
                                    name: (0, $irVI7.BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE),
                                    error: new Error(`Failed to open correct blueprint dialog ${response}`)
                                });
                            });
                        });
                    }, ()=>{
                        (0, $fGzMp.getExperienceTracker)().fail({
                            name: (0, $irVI7.BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE),
                            error: new Error('WRM is unavailable')
                        });
                    });
                }
            }
        };
    }
}
$968e924f2d44dea0$var$PseudoWizardCreateDialogComponent.displayName = 'PseudoWizardDialog';
$968e924f2d44dea0$var$PseudoWizardCreateDialogComponent.propTypes = {
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    templateOriginSpaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    blueprint: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    onContentUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    beforeUpdateRequest: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
$968e924f2d44dea0$var$PseudoWizardCreateDialogComponent.defaultProps = {
    onClose: ()=>{}
};
const $968e924f2d44dea0$export$337e634e35c15c89 = ()=>{
    const { showBlueprintVariableWizard: showBlueprintVariableWizard, parentPageId: parentPageId, spaceKey: spaceKey, templateOriginSpaceKey: templateOriginSpaceKey, title: title, onClose: onClose, blueprint: blueprint, contentId: contentId, onContentUpdated: onContentUpdated, beforeUpdateRequest: beforeUpdateRequest, onError: onError } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    if (showBlueprintVariableWizard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($968e924f2d44dea0$var$PseudoWizardCreateDialogComponent, {
        parentPageId: parentPageId,
        spaceKey: spaceKey,
        templateOriginSpaceKey: templateOriginSpaceKey,
        title: title,
        onClose: onClose,
        blueprint: blueprint,
        contentId: contentId,
        onContentUpdated: onContentUpdated,
        beforeUpdateRequest: beforeUpdateRequest,
        onError: onError,
        open: true
    });
    return null;
};
module.exports["CreateDialogBlueprintWizardRenderer"] = $968e924f2d44dea0$export$337e634e35c15c89;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});


//# sourceMappingURL=PseudoWizardCreateDialog.7a644381.js.map
